"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePagination = exports.initialPagination = exports.initialPageSize = exports.initialPage = exports.getOffset = void 0;
var _react = require("react");
var _reactRouter = require("react-router");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var initialPagination = exports.initialPagination = function initialPagination(query, callback) {
  var page = initialPage(query);
  var pageSize = initialPageSize(query);
  callback(page, pageSize);
};
var initialPage = exports.initialPage = function initialPage(query) {
  var value = parseInt(query.get('page') || '');
  return isNaN(value) ? 1 : value;
};
var initialPageSize = exports.initialPageSize = function initialPageSize(query) {
  var value = parseInt(query.get('pageSize') || '');
  if (isNaN(value) || value < 0) {
    return 20;
  }
  return Math.min(value, 500);
};
var getOffset = exports.getOffset = function getOffset(page, pageSize) {
  return (page - 1) * pageSize;
};
var usePagination = exports.usePagination = function usePagination(clearCallback) {
  var qs = (0, _reactRouter.useLocation)().search;
  var query = (0, _react.useMemo)(function () {
    return new URLSearchParams(qs);
  }, [qs]);
  var _useState = (0, _react.useState)(initialPage(query)),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var _useState3 = (0, _react.useState)(initialPageSize(query)),
    _useState4 = _slicedToArray(_useState3, 2),
    pageSize = _useState4[0],
    setPageSize = _useState4[1];
  var onChangedPage = (0, _react.useCallback)(function (page) {
    setPage(page);
    clearCallback();
  }, [clearCallback]);
  var onChangedPageSize = (0, _react.useCallback)(function (page, pageSize) {
    setPage(page);
    setPageSize(pageSize);
    clearCallback();
  }, [clearCallback]);
  var data = (0, _react.useMemo)(function () {
    return {
      page: page,
      pageSize: pageSize,
      onChangedPage: onChangedPage,
      onChangedPageSize: onChangedPageSize
    };
  }, [page, pageSize, onChangedPage, onChangedPageSize]);
  return data;
};